export default __webpack_public_path__ + "static/media/mutation-example.f5cd18f0.png";